import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronBoldRight = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M29.194 21.244 14.952 35.485c-.686.687-1.8.687-2.487 0l-1.66-1.661a1.759 1.759 0 0 1-.004-2.484L22.088 20 10.802 8.66a1.758 1.758 0 0 1 .003-2.484l1.661-1.661a1.759 1.759 0 0 1 2.487 0l14.241 14.242c.687.686.687 1.8 0 2.487Z" })
});
export default SvgChevronBoldRight;
